import { FC, PropsWithChildren } from 'react';
import { IonCardTitle } from '@ionic/react';
import { useTheme } from 'styled-components';

import styles from './CardTitle.module.scss';

type CardTitleProps = PropsWithChildren<{}>;

export const CardTitle: FC<CardTitleProps> = ({ children }) => {
  const { fontSize } = useTheme();

  return (
    <IonCardTitle
      className={styles.root}
      style={{ fontSize: fontSize(18), lineHeight: fontSize(23) }}
    >
      {children}
    </IonCardTitle>
  );
};
